import { createFileRoute } from '@tanstack/react-router';
import CircuitList from '~/containers/CircuitList';

export const Route = createFileRoute('/circuits/')({
  component: CircuitList,
  validateSearch(search) {
    return {
      page: search.page !== undefined ? Number(search.page) : undefined,
    };
  },
});
